import { ref, onMounted, onUnmounted } from 'vue'
import * as StompJs from '@stomp/stompjs'
import { AuthenticationService } from '@/services/AuthenticationService'
import { useConsultationRequestStore } from '@/stores/consultationRequest'

export function useCallRestartNotifications() {
  const stompClient = ref<StompJs.Client | null>(null)
  const processedRestartIds = new Set<string>()

  const BROKER_URL = '/api/consultation-participant-activity'
  const RESTART_DESTINATION = '/user/queue/call-restart'

  onMounted(() => {
    connect()
  })

  onUnmounted(() => {
    disconnect()
  })

  async function connect() {
    const accessToken = await AuthenticationService.updateAccessToken()

    const client = new StompJs.Client({
      brokerURL:
        (window.location.protocol === 'https:' ? 'wss://' : 'ws://') +
        window.location.host +
        BROKER_URL,
      connectHeaders: {
        Authorization: `Bearer ${accessToken}`
      }
    })

    stompClient.value = client

    client.onConnect = () => {
      client.subscribe(RESTART_DESTINATION, (message) => {
        try {
          const event = JSON.parse(message.body)
          if (event.restartId && !processedRestartIds.has(event.restartId)) {
            processedRestartIds.add(event.restartId)

            // Limit set size to avoid memory leaks
            if (processedRestartIds.size > 100) {
              const firstValue = processedRestartIds.values().next().value
              if (firstValue !== undefined) {
                processedRestartIds.delete(firstValue)
              }
            }

            const consultationStore = useConsultationRequestStore()
            Promise.all([
              consultationStore.refreshIncomingConsultationRequestList(),
              consultationStore.refreshOutgoingConsultationRequestList()
            ])
          }
        } catch (e) {
          console.error('Failed to parse call restart event', e)
        }
      })
    }

    client.activate()
  }

  function disconnect() {
    stompClient.value?.deactivate()
  }
}
